import { ReactNode } from 'react';
import { Button, FieldError, Label, ListBox, Popover, ComboBox as AriaComboBox, Text, Input } from 'react-aria-components';
import type { ComboBoxProps as AriaComboBoxProps, ValidationResult } from 'react-aria-components';



interface ComboBoxProps<T extends object> extends Omit<AriaComboBoxProps<T>, 'children'> {
	label?: string;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
	items?: Iterable<T>;
	children: ReactNode | ((item: T) => ReactNode);
}


export function ComboBox<T extends object>(props: ComboBoxProps<T>) {
	const { label, isRequired = false, description, errorMessage, children, ...otherProps } = props;
	return (
		<AriaComboBox {...otherProps} isRequired={isRequired}>
			
			{label &&
				<Label>{label} {isRequired && <span>*</span>}</Label>}
		
			<div className="component-combobox-container">
				<Input />
				<Button>▼</Button>
			</div>
		
			{description &&
				<Text slot="description">{description}</Text>}
		
			<FieldError>{errorMessage}</FieldError>
		
			<Popover>
				<ListBox>
					{children}
				</ListBox>
			</Popover>
		
		</AriaComboBox>
	);
}